<template>
  <!-- "Android / iOS" with a small logo before each word. Icons use currentColor. -->
  <span class="platform-list">
    <template v-for="(platform, i) in platforms" :key="platform">
      <span class="platform">
        <svg v-if="icon(platform)" class="platform-icon" viewBox="0 0 24 24" fill="currentColor" fill-rule="evenodd" role="img" :aria-label="platform">
          <title>{{ platform }}</title>
          <path v-for="(d, j) in icon(platform)" :key="j" :d="d" />
        </svg>{{ platform }}</span><span v-if="i < platforms.length - 1" class="sep"> / </span>
    </template>
  </span>
</template>

<script>
// Simple monochrome glyphs, drawn on a 24x24 grid.
const ICONS = {
  apple: [
    'M12 7.2c-1.4-.9-4.3-1.3-5.9.9-1.7 2.4-1 6.2.6 8.7 1 1.6 2.2 3.2 3.6 2.7.7-.3 1.1-.5 1.7-.5s1 .2 1.7.5c1.4.5 2.6-1.1 3.6-2.7 1.6-2.5 2.3-6.3.6-8.7-1.6-2.2-4.5-1.8-5.9-.9z',
    'M12.1 6.4c-.1-2 1.1-3.7 3.1-4.2.2 2-1.1 3.8-3.1 4.2z'
  ],
  android: [
    'M6 10.5h12v7a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 17.5z',
    'M6 9.5a6 6 0 0 1 12 0zM9.3 6.8a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6zm5.4 0a.8.8 0 1 0 0 1.6.8.8 0 0 0 0-1.6z',
    'M7.6 3.2l1.6 2.4-.5.3-1.6-2.4zM16.4 3.2l.5.3-1.6 2.4-.5-.3z',
    'M3.5 11h1.6v5.5H3.5zM18.9 11h1.6v5.5h-1.6zM8.5 18.5h1.8v3H8.5zM13.7 18.5h1.8v3h-1.8z'
  ],
  monitor: [
    'M3 4h18a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm1 2v9h16V6z',
    'M9 18h6l1 2.5H8z'
  ],
  windows: [
    'M3 5.5l7.5-1v7H3zM11.5 4.3L21 3v8.5h-9.5zM3 12.5h7.5v7L3 18.5zM11.5 12.5H21V21l-9.5-1.3z'
  ],
  vr: [
    'M4 7h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-4.2l-1.8-2.5a2.4 2.4 0 0 0-4 0L8.2 17H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zm3.5 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm9 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z'
  ],
  phone: [
    'M8 2h8a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 3v13h8V5zm4 14.2a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8z'
  ]
};

const PLATFORM_ICON = {
  ios: 'apple',
  android: 'android',
  pc: 'monitor',
  windows: 'windows',
  'pc vr': 'vr',
  vr: 'vr',
  mobile: 'phone'
};

export default {
  name: 'PlatformList',
  props: {
    platforms: {
      type: Array,
      required: true
    }
  },
  methods: {
    icon(platform) {
      return ICONS[PLATFORM_ICON[platform.toLowerCase()]] || null;
    }
  }
}
</script>

<style scoped>
.platform-list {
  display: inline;
}
.platform {
  white-space: nowrap;
}
.platform-icon {
  width: 1em;
  height: 1em;
  margin-right: 0.25em;
  vertical-align: -0.15em;
}
</style>
